import api from './api';

export const notificationApi = {
  getNotifications: async (limit = 20, offset = 0) => {
    return await api.get(`/notifications?limit=${limit}&offset=${offset}`);
  },

  getUnreadCount: async () => {
    return await api.get('/notifications/unread');
  },

  markAsRead: async (id) => {
    return await api.post(`/notifications/${id}/read`);
  },

  markAllAsRead: async () => {
    return await api.post('/notifications/read-all');
  },

  deleteNotification: async (id) => {
    return await api.delete(`/notifications/${id}`);
  },
};
